var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownCaret(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 559,
    height: 318,
    viewBox: "0 0 559 318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M279.5 318C274.433 318.006 269.416 317.012 264.735 315.073C260.054 313.135 255.802 310.29 252.225 306.704L11.267 65.8049C4.0468 58.5698 -0.00559576 48.7652 5.79949e-06 38.545C0.00560736 28.3247 4.06875 18.5246 11.2969 11.2973C18.525 4.0701 28.3271 0.00680121 38.5498 8.5302e-06C48.7726 -0.00678415 58.58 4.04348 65.8177 11.2611L279.5 224.888L493.182 11.2611C500.42 4.04348 510.227 -0.00678415 520.45 8.5302e-06C530.673 0.00680121 540.475 4.0701 547.703 11.2973C554.931 18.5246 558.994 28.3247 559 38.545C559.006 48.7652 554.953 58.5698 547.733 65.8049L306.775 306.704C303.198 310.29 298.946 313.135 294.265 315.073C289.584 317.012 284.567 318.006 279.5 318Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownCaret);
export default __webpack_public_path__ + "static/media/DownCaret.e16371467feac1aedc94fd549f3aa8ee.svg";
export { ForwardRef as ReactComponent };